import { Component, OnInit, forwardRef } from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';
import {AbstractFieldClass} from '../abstract-field.class';
import { DirectoryService } from './../../../services/directory.service';

declare const $: any;

@Component({
    selector: 'resident-alternative-emails-field',
    templateUrl: './resident-alternative-emails-field.template.html',
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ResidentAlternativeEmailsFieldComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => ResidentAlternativeEmailsFieldComponent), multi: true}
    ],
    styleUrls: ['resident-alternative-emails-field.style.scss']
})
export class ResidentAlternativeEmailsFieldComponent extends AbstractFieldClass implements OnInit { 
    
    constructor(
        public directoryService: DirectoryService
    ) {
        super();
    }
    
    ngOnInit() {
        super.ngOnInit();
    }

    addNew(): void {
        this.value.push({email: ''});
        
    }
    
    onSubmit(el, i) { 
        this.value[i].email = el.value;
        this.update.emit();
    }
    
    onCanceled(i) { 
        let reg = /^[A-Z0-9._%+-]+@[A-Z0-9-]+.+.[A-Z]{2,4}$/i;
        if (!reg.test(this.value[i].email)) { 
            this.value = this.filterEmail(this.value[i].email);
        }
    }
    
    onDelete(value) { 
        this.value = this.filterEmail(value);
        this.update.emit();
    }
    
    filterEmail(value) { 
        return this.value.filter(item => item.email != value);
    }
    
    validator(value: any): boolean {
        return undefined; 
    }
}


// WEBPACK FOOTER //
// /app/src/app/components/fields/resident-alternative-emails-field/resident-alternative-emails-field.component.ts